module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('h1', [_vm._v("Acknowledgment")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("I am thankful for the assistance provided by my husband, Ivan Arthur, for his support and encouragement. I am grateful for the assistance, ongoing encouragement and instructions received to begin my writing and organize my thoughts. I appreciate all those conversations with family members, friends, and church members, who have listened to my ideas and enhanced my learning of the gospel.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Even though I have considered the thoughts and assistance of other acquaintances, I am solely responsible for the concepts, ideas, and views that I have expressed in "), _c('em', [_vm._v("Treasure in Heaven")]), _vm._v(". This book is not an official statement of the Church doctrine, principles, or truths.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0